import { combineReducers } from "redux";
import { CLEAR_ACCOUNT_DATA } from "constants/actionTypes";

import allTimeStats from "reducers/account/allTimeStats";
import analytics from "reducers/analytics";
import analyticsV2 from "reducers/account/analytics-v2";
import categories from "reducers/account/categories";
import checklists from "reducers/account/checklists";
import conditions from "reducers/account/conditions";
import contentStatus from "reducers/account/contentStatus";
import dashboard from "reducers/account/dashboard";
import features from "reducers/account/features";
import flows from "reducers/account/flows";
import flowStatus from "reducers/account/flowStatus";
import flowVersions from "reducers/account/flowVersions";
import goals from "reducers/account/goals";
import goalStats from "reducers/account/goalStats";
import images from "reducers/account/images";
import installedDomains from "reducers/account/installedDomains";
import integrations from "reducers/account/integrations";
import locales from "reducers/account/locales";
import meta from "reducers/account/meta";
import profileAttributes from "reducers/account/profileAttributes";
import requests from "reducers/account/requests";
import rules from "reducers/account/rules";
import satisfaction from "reducers/account/satisfaction";
import segments from "reducers/account/segments";
import segmentMemberships from "reducers/account/segmentMemberships";
import stats from "reducers/account/stats";
import tags from "reducers/account/tags";
import themes from "reducers/account/themes";
import translations from "reducers/account/translations";
import userEvents from "reducers/account/userEvents";
import userProfiles from "reducers/account/userProfiles";
import users from "reducers/account/users";
import versionedFlows from "reducers/account/versionedFlows";

const combined = combineReducers({
  allTimeStats,
  analytics,
  analyticsV2,
  categories,
  checklists,
  conditions,
  contentStatus,
  dashboard,
  features,
  flows,
  flowStatus,
  flowVersions,
  goals,
  goalStats,
  images,
  installedDomains,
  integrations,
  locales,
  meta,
  profileAttributes,
  requests,
  rules,
  satisfaction,
  segments,
  segmentMemberships,
  stats,
  tags,
  themes,
  translations,
  userEvents,
  userProfiles,
  users,
  versionedFlows
});

export default function account(state, action) {
  const shouldClear = action.type === CLEAR_ACCOUNT_DATA;
  return combined(shouldClear ? undefined : state, action);
}
